import React from 'react'
import { connect } from 'react-redux'
import { Formik, Form } from 'formik'
import {
  Button, FormGroup, Input, InputGroupText, FormText, UncontrolledTooltip,
} from 'reactstrap'
import * as Yup from 'yup'
import {
  Loading, FieldGroup, Label, HintIcon, InputGroupAddon,
} from 'lib/components'
import { mailSenderInfoAction } from 'actions'

const validationSchema = Yup.object().shape({
  prohibitFromLine: Yup.string().test('prohibitFromLine', '開始時刻を設定してください', function(value) {
    const { prohibitToLine } = this.parent
    if (prohibitToLine && !value) return false
    return true
  }),
  prohibitToLine: Yup.string().test('prohibitToLine', '終了時刻を設定してください', function(value) {
    const { prohibitFromLine } = this.parent
    if (prohibitFromLine && !value) return false
    return true
  }),
  generalUrlParam: Yup.string().nullable(),
  useMultipart: Yup.bool(),
  sendToCarrier: Yup.bool(),
})

export const LineSenderInfoEditForm = ({ mailSenderInfo, dispatch }) => {
  const item = mailSenderInfo.item
  return (
    <Loading isLoading={mailSenderInfo.isFetching}>
      <Formik
        initialValues={{
          prohibitFromLine: item.prohibitFromLine || '',
          prohibitToLine: item.prohibitToLine || '',
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          dispatch(mailSenderInfoAction.submitUpdateLineSenderInfo(values))
        }}
      >
        {({ values }) => (
          <Form noValidate>
            <legend className="mb-0">配信停止設定<HintIcon id="prohibitPointTooltip" className="ml-1" style={{ 'fontSize': '14px' }} /></legend>
            <FormText className="mb-3" tag="span">
              強制的にLINE配信を停止する時間です。停止時間に配信される予定だったLINEは、停止時間が明けた後に配信されます。<br />
              設定は放棄系LINEキャンペーンのみ適用されます。
            </FormText>
            <fieldset>
              <FormGroup>
                <Label>配信停止時間設定（LINE）</Label>
                <FieldGroup>
                  <Input name="prohibitFromLine" type="time" />
                  <InputGroupAddon addonType="middle">
                    <InputGroupText>〜</InputGroupText>
                  </InputGroupAddon>
                  <Input name="prohibitToLine" type="time" />
                </FieldGroup>
                <SpanNote from={values.prohibitFromLine} to={values.prohibitToLine} />
              </FormGroup>
            </fieldset>
            <div className="text-center"><Button color="primary" type="submit" size="lg">保存</Button></div>
            <Tooltips />
          </Form>
        )}
      </Formik>
    </Loading>
  )
}

const Tooltips = () => (
  <>
    <UncontrolledTooltip placement="right" target="prohibitPointTooltip">
      ️夜間にLINEが届いて欲しくないユーザーが多いと予想される場合は深夜帯を停止時間に設定するなど、サイトのユーザー属性に応じて設定することがおすすめです！
    </UncontrolledTooltip>
  </>
)

const SpanNote = ({ from, to }) => {
  if(!from || !to) {
    return (
      <FormText>配信停止設定はありません</FormText>
    )
  }
  if(to < from) {
    return (
      <FormText>{from} ~ 翌{to}の間は配信停止します</FormText>
    )
  }
  return (
    <FormText>{from} ~ {to}の間は配信停止します</FormText>
  )
}

const select = ({ mailSenderInfo }) => ({ mailSenderInfo })

export default connect(select)(LineSenderInfoEditForm)
